//-------- Stamped.io Review Scroll Override --------//
// Override Stamped.io's scroll behavior to account for sticky header
function setupStampedScrollOverride() {
  // Use event delegation on document to catch dynamically loaded Stamped buttons
  document.addEventListener('click', function(e) {
    // Check if clicked element or its parents match the Stamped review button or badge
    const stampedButton = e.target.closest('#stamped-summary-actions-newreview, .stamped-summary-actions-newreview, [data-stamped-action="newreview"]');
    const stampedBadge = e.target.closest('.stamped-product-reviews-badge, [class*="stamped"][class*="badge"]');
    
    if (stampedButton || stampedBadge) {
      e.preventDefault();
      e.stopPropagation();
      
      // Find the target element - form for button, main widget for badge
      let targetElement;
      
      if (stampedButton) {
        // For "Write Review" button, find the form
        targetElement = document.querySelector('.new-review-form, #new-review-form, [id^="new-review-form_"]');
        
        // Show the form
        if (targetElement) {
          targetElement.style.display = 'block';
          targetElement.setAttribute('aria-expanded', 'true');
        }
      } else if (stampedBadge) {
        // For badge clicks, scroll to the main reviews widget
        targetElement = document.querySelector('#stamped-main-widget');
      }
      
      if (targetElement) {
        // Determine scroll direction
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const currentPosition = window.pageYOffset;
        const willScrollUp = targetPosition < currentPosition;
        
        // Calculate sticky offset based on scroll direction
        const stickyAddToCartBannerHeight = document.querySelector('.sticky-add-to-cart-banner ')?.offsetHeight || 0;
        const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
        const totalHeight = stickyAddToCartBannerHeight + headerHeight;
        
        let totalOffset;
        if (willScrollUp) {
          // Scrolling up - header will be visible
          document.documentElement.style.setProperty('--scroll-margin-top', `${totalHeight}px`);
          totalOffset = totalHeight;
        } else {
          // Scrolling down - header will be hidden
          totalOffset = stickyAddToCartBannerHeight;
        }

        if (window.innerWidth < 990) {
          totalOffset = totalOffset + 60;
        }

        // Update CSS variable BEFORE scrolling
        document.documentElement.style.setProperty('--scroll-margin-top', `${totalOffset}px`);
        
        // Use scrollIntoView which respects scroll-margin-top
        targetElement.scrollIntoView({
          block: 'start'
        });
      }
    }
  }, true); // Use capture phase to intercept before Stamped's handlers
}

// Run after a short delay to ensure Stamped.io has loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(setupStampedScrollOverride, 500);
  });
} else {
  setTimeout(setupStampedScrollOverride, 500);
}
